// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1k1N_","content":"styles_content__daJ0b"};